import api from './api';

export interface CreateLeadPayload {
  customerName: string;
  customerPhone: string;
  suggestedBranch: string;
  suggestedModel: string;
  otherComments?: string;
}

export type LeadSubmitter = {
  id: string;
  fullName: string;
  empNo: string;
  branch: string;
  telNo: string | null;
};

export type AdminLeadRow = {
  id: string;
  customerName: string;
  customerPhone: string;
  suggestedBranch: string;
  suggestedModel: string;
  otherComments: string | null;
  createdAt: string;
  followedByEmpNo: string | null;
  followedByName: string | null;
  followedAt: string | null;
  submittedBy: LeadSubmitter | null;
};

export type LeadLeaderboardEntry = {
  userId: string;
  fullName: string;
  department: string;
  branch: string;
  profilePicture: string | null;
  leadCount: number;
};

export type MyLeadStats = {
  leadCount: number;
  points: number;
  rank: number | null;
};

export const leadsService = {
  async submit(payload: CreateLeadPayload): Promise<{ id: string; message: string }> {
    const response = await api.post('/leads', payload);
    return response.data;
  },

  async listForAdmin(): Promise<AdminLeadRow[]> {
    const response = await api.get<AdminLeadRow[]>('/leads');
    return response.data;
  },

  async followLead(id: string): Promise<void> {
    await api.patch(`/leads/${id}/follow`);
  },

  async unfollowLead(id: string): Promise<void> {
    await api.patch(`/leads/${id}/unfollow`);
  },

  async getUnfollowedCount(): Promise<number> {
    const response = await api.get<{ count: number }>('/leads/unfollowed-count');
    return response.data.count;
  },

  async deleteLeads(ids: string[]): Promise<void> {
    await api.delete('/leads/bulk', { data: { ids } });
  },

  /** Top 10 lead referrers — available to any authenticated user. */
  async getLeaderboard(): Promise<LeadLeaderboardEntry[]> {
    const response = await api.get<LeadLeaderboardEntry[]>('/leads/leaderboard');
    return response.data;
  },

  /** Current user's own lead count, points and leaderboard rank. */
  async getMyStats(): Promise<MyLeadStats> {
    const response = await api.get<MyLeadStats>('/leads/my-stats');
    return response.data;
  },
};
